<template>
  <v-list dense nav>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title">Localrent</v-list-item-title>
        <v-list-item-subtitle>Admin</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item-group>
      <v-list-item link :to="{ name: 'home' }" exact>
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
    <div v-if="authenticated" class="py-2">
      <template v-for="(item, i) in items">
        <v-list-item link :to="{ name: item.path }" exact v-if="!item.children" :key="item.title">
          <v-list-item-action>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group v-else :prepend-icon="item.icon" value="true" :key="i" color="white">
          <template v-slot:activator>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </template>

          <v-list-item-group dense class="ml-3">
            <v-list-item
              class="pl-2"
              v-for="(child, j) in item.children"
              :key="i + '' + j"
              link
              :to="{ name: child.path }"
            >
              <v-list-item-icon>
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ child.title }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <v-divider></v-divider>
      </template>
    </div>
    <div v-else>
      <v-list-item-group>
        <v-list-item link :to="{ name: 'SignIn' }">
          <v-list-item-action>
            <v-icon>mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </div>
  </v-list>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("nav", {
      items: "nav"
    }),
    ...mapState("auth", ["authenticated"])
  }
};
</script>
